import React from 'react';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import GlobalButton from '@/src/components/Antd/Button/Button';
import Row from '@/src/components/Layouts/Row/Row';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import TextArea from '@/src/components/Antd/TextArea/TextArea';
// import FormItem from '../../components/FormItem/FormItem';
//import Configuration from '@/src/components/Configuration/Configuration';
import CountWords from '@/src/components/CountWords/CountWords';
import Select, {
  OptionsList,
  generateOptions,
} from '@/src/components/Antd/Select/Select';
import Input from '@/src/components/Antd/Input/Input';
import SmartInput from '@/src/components/SmartInput/SmartInput';
import css from './css.less';
import { PlusOutlined } from '@ant-design/icons';
import AddUnit from 'src/constrains/SingleAddModal/AddUnit';
import AddCode from '../AddCodeModal/AddCode';
import { IBrand, MeasurementUnit } from '@/src/types/common/product';
import Status from 'src/pages/ProductEditor/Components/StatusTag/Status';
import { EDangerousType } from 'src/types/common/product';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  brands: IBrand[];
  measurementUnits: MeasurementUnit[];
  setShowModal: (visible) => void;
  setModalTitle: (title) => void;
  // setOkText: (text) => void;
  setModalContent: (child) => void;
  otherCodeForm;
  formdata;
  deletePopFun;
  codesOnChange;
  setData;
  setCodes;
  otherCodeFormFinish;
  status;
  setDraft: () => void;
  setActive: () => void;
  setArchived: () => void;
  addUnit: (unit) => void;
  addBrand: (brand) => void;
  title: string;
  disabled?: boolean;
}

const ProductInfo = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const _dOptions = [
    {
      label: getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_Explosives',
      ),
      value: EDangerousType.Explosives,
    },
    {
      label: getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_Gases',
      ),
      value: EDangerousType.Gases,
    },
    {
      label: getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_Flammable_Liquids',
      ),
      value: EDangerousType.FlammableLiquids,
    },
    {
      label: getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_Oxidizing_And_Peroxide',
      ),
      value: EDangerousType.OxidizingAndPeroxide,
    },
    {
      label: getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_Toxic',
      ),
      value: EDangerousType.Toxic,
    },
    {
      label: getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_Radioactive',
      ),
      value: EDangerousType.Radioactive,
    },
    {
      label: getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_Corrosive',
      ),
      value: EDangerousType.Corrosive,
    },
    {
      label: getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_Miscellaneous',
      ),
      value: EDangerousType.Miscellaneous,
    },
  ];
  const {
    setShowModal,
    setModalTitle,
    // setOkText,
    setModalContent,
    otherCodeForm,
    formdata,
    deletePopFun,
    codesOnChange,
    setData,

    setDraft,
    setActive,
    setArchived,
    brands = [],
    measurementUnits = [],
    addUnit,
    addBrand,
    title,
    status,
    disabled,
  } = props;

  const {
    sku = '',
    name = '',
    remarks = '',
    measurementUnit,
    brand,
    barcode,
    codes = [],

    // measurementUnits = [],
    // brands = [],
    skuError,
    nameError,
    description = '',
    dangerousGoodsClasses,
  } = formdata;

  const unitOnSubmit = (unit) => {
    if (addUnit) addUnit(unit);
    // setData({
    //   measurementUnits: [
    //     ...measurementUnits,
    //     { name: unit, uuid: JSON.stringify(new Date()) },
    //   ],
    // });
  };
  const brandOnSubmit = (brand) => {
    if (addBrand) addBrand(brand);
    // setData({
    //   brands: [...brands, { name: brand, uuid: JSON.stringify(new Date()) }],
    // });
  };
  const codeOnSubmit = (code) => {
    setData({
      codes: [...codes, code],
    });
  };
  const selectOptionConvert = (arr = []): OptionsList[] => {
    return arr.map((i) => {
      return {
        label: i.name,
        value: i.uuid,
      };
    });
  };
  const addInputData = () => {
    setShowModal(true);
    setModalTitle(
      getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_add_othercode',
      ),
    );
    otherCodeForm.resetFields();
    const child = (
      <AddCode
        setModal={setShowModal}
        onSubmit={codeOnSubmit}
        firstMaxLength={50}
        secondMaxLength={50}
        currentCodes={codes || []}
      />
    );
    setModalContent(child);
  };

  const brandBtnClick = () => {
    setShowModal(true);
    setModalTitle(
      getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_add_newproductbrand',
      ),
    );
    // setOkText('Create');
    const child = (
      <Row
        elements={[
          {
            child: (
              <AddUnit
                title={getI18n(
                  'allProducts.addproductset.productInfo_component_productinfo_brand_title',
                )}
                setModal={setShowModal}
                onSubmit={brandOnSubmit}
                maxLength={50}
                currentData={brands}
              />
            ),
          },
        ]}
      />
    );
    setModalContent(child);
  };
  const unitBtnClick = () => {
    setShowModal(true);
    setModalTitle(
      getI18n(
        'allProducts.addproductset.productInfo_component_productinfo_add_measurement',
      ),
    );
    // setOkText('Create');
    const child = (
      <Row
        elements={[
          {
            child: (
              <AddUnit
                title={getI18n(
                  'allProducts.addproductset.productInfo_component_productinfo_unit_of_measure_short',
                )}
                setModal={setShowModal}
                onSubmit={unitOnSubmit}
                maxLength={50}
              />
            ),
          },
        ]}
      />
    );
    setModalContent(child);
  };
  const barcodeDisable = React.useMemo(() => {
    if ((codes || []).length < 10) {
      return false;
    }
    return true;
  }, [(codes || []).length]);

  const skuFilter = (str) => {
    if (str) {
      return str.replace(/\s+/g, '');
    } else {
      return str;
    }
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      title={
        <Status
          disabled={disabled}
          status={status}
          setArchived={setArchived}
          setActive={setActive}
          setDraft={setDraft}
          title={title}
        />
      }>
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                id='ProductEditorProductName'
                rightPart={
                  <CountWords count={(name || '').length} allCount={100} />
                }
                title={`${getI18n('general.productName')}*`}>
                <TextArea
                  disabled={disabled}
                  // status={EnumFormItemStatus.error}
                  // help={'test'}
                  error={nameError}
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  size='large'
                  value={name}
                  maxLength={100}
                  onChange={(value) => setData({ name: value })}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'allProducts.addproductset.productInfo_component_productinfo_unit_of_measure_short',
                )}>
                <Select
                  disabled={disabled}
                  optionsList={generateOptions(
                    measurementUnits,
                    'unit',
                    'uuid',
                  )}
                  rightBtn={{ type: 'add', clickFun: unitBtnClick, disabled }}
                  value={(measurementUnit || {}).uuid}
                  onChange={(value, option) => {
                    setData({
                      measurementUnit: {
                        unit: option.children,
                        uuid: value,
                      },
                    });
                  }}
                  size='large'></Select>
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords count={(remarks || '').length} allCount={500} />
                }
                title={getI18n('general.remarks')}
                rightSubTitle={getI18n(
                  'allProducts.addproductset.productInfo_component_productinfo_remarks_rightSubTitle',
                )}
                help='1111111'
                validateStatus='error'>
                <TextArea
                  disabled={disabled}
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  value={remarks}
                  onChange={(value) => setData({ remarks: value })}
                  maxLength={500}
                  size='large'
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords count={(sku || '').length} allCount={50} />
                }
                title={`${getI18n('general.sKU')}*`}>
                <Input
                  disabled={disabled}
                  error={skuError}
                  placeholder={getI18n(
                    'allProducts.addproductset.productInfo_component_productinfo_sku_rightSubTitle',
                  )}
                  maxLength={50}
                  value={sku}
                  onChange={(value) => setData({ sku: value })}
                  size='large'
                  customFilter={skuFilter}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <div style={{ width: '100%' }}>
                <ItemWrapper
                  title={getI18n(
                    'allProducts.addproductset.productInfo_component_productinfo_brand_title',
                  )}>
                  <Select
                    disabled={disabled}
                    optionsList={selectOptionConvert(brands)}
                    size='large'
                    value={(brand || {}).uuid}
                    onChange={(value, option) => {
                      console.log(value, option);
                      setData({
                        brand: {
                          name: option.children,
                          uuid: value,
                        },
                      });
                    }}
                    rightBtn={{
                      type: 'add',
                      clickFun: brandBtnClick,
                      disabled,
                    }}></Select>
                </ItemWrapper>
              </div>
            ),
          },
          {
            child: (
              <ItemWrapper
                title={getI18n(
                  'allProducts.addproductset.productInfo_component_productinfo_dangerousGoods_title',
                )}>
                <Select
                  disabled={disabled}
                  placeholder={getI18n(
                    'allProducts.addproductset.productInfo_component_productinfo_Select_placeholder',
                  )}
                  allowClear
                  mode='multiple'
                  size='large'
                  showArrow
                  optionsList={_dOptions}
                  onChange={(value) => {
                    console.log(value);
                    setData({
                      dangerousGoodsClasses: value,
                    });
                  }}
                  value={dangerousGoodsClasses}
                />
              </ItemWrapper>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords
                    count={(description || '').length}
                    allCount={500}
                  />
                }
                title={getI18n(
                  'allProducts.addproductset.productInfo_component_productinfo_product_desc',
                )}>
                <TextArea
                  disabled={disabled}
                  maxLength={500}
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  size='large'
                  onChange={(value) => setData({ description: value })}
                  value={description}
                />
              </ItemWrapper>
            ),
          },
          {
            child: (
              <ItemWrapper
                rightPart={
                  <CountWords count={(barcode || '').length} allCount={150} />
                }
                rightSubTitle={getI18n(
                  'allProducts.addproductset.barcodeSubTitle',
                )}
                title={getI18n('allProducts.addproductset.barcode')}>
                <Input
                  disabled={disabled}
                  maxLength={150}
                  size='large'
                  value={barcode}
                  onChange={(value) => setData({ barcode: value })}
                />
                <SmartInput
                  disabled={disabled}
                  otherCodeList={codes}
                  maxLength={50}
                  onChange={codesOnChange}
                  confirm={(index) => deletePopFun(index)}
                />
                <GlobalButton
                  disabled={disabled || barcodeDisable}
                  className={css.addOtherBtn}
                  type='text'
                  icon={<PlusOutlined />}
                  onClick={() => addInputData()}>
                  {getI18n(
                    'allProducts.addproductset.productInfo_component_productinfo_add_othercode',
                  )}
                </GlobalButton>
              </ItemWrapper>
            ),
          },
        ]}
      />
      {/* <Row
        elements={[
          {
            child: <Configuration />,
          },
        ]}
      /> */}
    </SectionWrapper>
  );
};
export default ProductInfo;
